// extracted by mini-css-extract-plugin
export var burger_menu = "header-module--burger_menu--Fo3-k";
export var header = "header-module--header--Nc+7L";
export var header_bottom = "header-module--header_bottom--pefZo";
export var header_bottomlogged = "header-module--header_bottomlogged--oovnG";
export var header_main_container = "header-module--header_main_container--JQccG";
export var header_mobile_number = "header-module--header_mobile_number--L2cwY";
export var header_top = "header-module--header_top--sF4yY";
export var left_header_main = "header-module--left_header_main--cdiK2";
export var support_modal = "header-module--support_modal--s423g";
export var support_nav = "header-module--support_nav--h93Cs";
export var top_heading_container = "header-module--top_heading_container--mJ5PP";